module.exports = __webpack_public_path__ + "static/media/download-bottom.37e3a90a.svg";